import { Component, OnInit, Input } from '@angular/core';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { PermissionHelper, ComponentID, ActionType } from '../../../shared/helpers/permissionshelper';
import { Logging } from '../../../logging';

@Component({
  selector: 'app-cashout-approved',
  templateUrl: './cashout-approved.component.html',
  styleUrls: []
})
export class CashoutApprovedComponent implements OnInit {

  
  constructor(private helpers : HelpersService,
    private permhelper:PermissionHelper, 
    private componentid : ComponentID ,
    private actiontype: ActionType) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/client/cashout/cashout-approved/cashout-approved.component.ts